import { makeGetRequest } from 'owa-ows-gateway/lib/makeServiceRequest';
import { getGuid } from 'owa-guid';
import { GRIFFIN_REQUEST_BASEURL, USER_SETTINGS } from '../helpers/TxpConstants';
import { format } from 'owa-strings';
import { logCalendarUsage } from 'owa-shared-analytics';
import TxpSettingsEntryPoint from '../store/schema/TxpSettingsEntryPoint';
import EntityType from 'txp-data/lib/schema/innerSchema/EntityType';

export default function getUserSettingsAction(
    shouldLogDatapoint?: boolean,
    entryPoint?: TxpSettingsEntryPoint,
    entityType?: EntityType
): Promise<Response> {
    if (shouldLogDatapoint) {
        logCalendarUsage('TxpSettingsLoad', getTxpSettingsLoadCustomData(entryPoint, entityType));
    }

    return makeGetRequest(
        format(GRIFFIN_REQUEST_BASEURL, USER_SETTINGS),
        getGuid(),
        true /*returnFullResponse*/,
        null /*customHeaders*/,
        null /*throwServiceError*/
    );
}

function getTxpSettingsLoadCustomData(entryPoint: TxpSettingsEntryPoint, entityType: EntityType) {
    return {
        entryPoint: entryPoint,
        entityType: entityType,
    };
}
